<script>
  import { _ } from 'svelte-i18n'
  import ExtensionButton from '../../../components/ExtensionButton.svelte'
  export let browser = {name: 'your browser'}
</script>

<h2>
  {$_('inserts.yourFonts.didYou')}<br>
  You can see them here with Google Chrome or Microsoft Edge browsers.
</h2> 
<ExtensionButton/>
<p>
  {$_('inserts.yourFonts.lfaSupport')}<br>
  Unfortunately {browser.name} does not support this feature yet. <a href="/help/font-detection/" target="_blank">{$_('inserts.yourFonts.readMore')}</a>
</p>